const setGlobals = () => {
  if (typeof window === "undefined") {
    global.__BROWSER__ = false;
    global.__DEV__ = true;
    global.__appConfig__ = process.env.appConfig;
  } else {
    window.__BROWSER__ = true;
    window.__DEV__ = true;
    window.__appConfig__ = process.env.appConfig;
  }
};

setGlobals();
